import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

// Console-style filter chip: "Label Value ▾" button opening a menu.
export function FilterChip({
  label,
  value,
  options,
  onSelect,
  contentClassName,
}: {
  label: string;
  value: string;
  options: Array<{ key: string; label: string }>;
  onSelect: (key: string) => void;
  // Long lists: e.g. "max-h-80 overflow-y-auto".
  contentClassName?: string;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5 font-normal">
          <span className="text-muted-foreground">{label}</span>
          <span className="font-medium">{value}</span>
          <ChevronDown className="size-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className={contentClassName}>
        {options.map((o) => (
          <DropdownMenuItem key={o.key} onClick={() => onSelect(o.key)}>
            {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
